const config = {
  code: "+7 812",
  phone: "701-06-33",
  email: "",
};

export default config;
